export const LOADSTREETS_START = 'react/streets/LOADSTREETS_START';
export const LOADSTREETS_COMPLETE = 'react/streets/LOADSTREETS_COMPLETE';
export const LOADSTREETS_ERROR = 'react/streets/LOADSTREETS_ERROR';
export const CHANGESTREETS = 'react/streets/CHANGESTREETS';
export const ADDSTREETS = 'react/streets/ADDSTREETS';
export const CREATE_STREET = 'react/streets/CREATE_STREET';
export const STREETS_DESTROY = 'react/streets/STREETS_DESTROY';

const initialState = {
  list: [],
  created: [],
  value: '',
  manyStreets: false,
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADSTREETS_COMPLETE: {
      const created = [...state.created];
      if (action.result) {
        return {
          ...state,
          list: [...action.result.streets, ...created],
          loading: false
        };
      }
      return {
        ...state,
        list: [...created],
        loading: false
      };
    }
    case LOADSTREETS_START:
      return {
        ...state,
        loading: true
      };
    case LOADSTREETS_ERROR:
      return {
        ...state,
        loading: false
      };
    case CHANGESTREETS:
      return {
        ...state,
        value: action.data || { label: '', value: '' }
      };
    case ADDSTREETS: {
      const created = state.created.filter(x => x.localityId === action.localityId);
      try {
        return {
          ...state,
          list: [...action.data.streets, ...created],
          manyStreets: action.data.manyStreets,
        };
      } catch (err) {
        return {
          ...state,
          list: [...created],
        };
      }
    }
    case CREATE_STREET:
      return {
        ...state,
        list: [...state.list, action.data],
        created: [...state.created, action.data],
        value: action.data
      };
    case STREETS_DESTROY:
      return {
        ...state,
        list: [],
        value: '',
        loading: false
      };
    default:
      return state;
  }
}

export function loadStreets(data, type) {
  if (data && type) {
    return {
      types: [LOADSTREETS_START, LOADSTREETS_COMPLETE, LOADSTREETS_ERROR],
      promise: (client) => client.get('/api/address/' + type + '/' + data)
    };
  }
  return {
    type: 'CHANGESTREETS',
    data,
    addressObject: type
  };
}

export function searchStreets(e, ids) {
  const body = {
    regionId: ids.regionId,
    areaId: ids.areaId,
    cityId: ids.cityId,
    localityId: ids.localityId,
    text: e
  };
  return {
    types: [LOADSTREETS_START, LOADSTREETS_COMPLETE, LOADSTREETS_ERROR],
    promise: (client) => client.post('/api/address/streets', {
      data: body
    })
  };
}

export function changeStreets(data) {
  return {
    type: CHANGESTREETS,
    data
  };
}

export function addStreets(data, localityId) {
  return {
    type: ADDSTREETS,
    data,
    localityId
  };
}

export function createStreet(data) {
  return {
    type: CREATE_STREET,
    data
  };
}

export function destroyStreets() {
  return { type: STREETS_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/streets.js